export const IconosActivos = [
	{ id: 7, icono: './assets/media/activos/activo-azul.png' },
	{ id: 8, icono: './assets/media/activos/activo-morado.png' }
];

export const IconosTelefonos = [
	{ id: 7, icono: './assets/media/telefonos/telefono-azul.png' },
	{ id: 8, icono: './assets/media/telefonos/telefono-morado.png' }
]

export const IconoVehiculo = [
	{ id: 0, icono: './assets/media/autos/auto_gris.png' },
	{ id: 1, icono: './assets/media/autos/auto_verde.png' },
	{ id: 2, icono: './assets/media/autos/auto_rojo.png' },
	{ id: 3, icono: './assets/media/autos/auto_amarillo.png' },
	{ id: 4, icono: './assets/media/autos/auto_amarillo.png' },
	{ id: 5, icono: './assets/media/autos/auto_naranja.png' },
	{ id: 6, icono: './assets/media/autos/auto_rojo.png' },
	{ id: 7, icono: './assets/media/autos/auto_azul.png' },
	{ id: 8, icono: './assets/media/autos/auto_morado.png' },
	{ id: 9, icono: './assets/media/autos/auto_rosa.png' },
	{ id: 10, icono: './assets/media/autos/auto_cafe.png' },
	{ id: 11, icono: './assets/media/autos/auto_gris.png' },
]

export const SpinnerApuntador = [
	{ id: 0, icono: './assets/media/puntos/spinnerGris.png' },
	{ id: 1, icono: './assets/media/puntos/spinner.png' },
	{ id: 2, icono: './assets/media/puntos/spinnerAlerta.png' },
	{ id: 3, icono: './assets/media/puntos/spinnerAmarillo.png' },
	{ id: 4, icono: './assets/media/puntos/spinnerAmarillo.png' },
	{ id: 5, icono: './assets/media/puntos/spinnerNaranja.png' },
	{ id: 6, icono: './assets/media/puntos/spinnerRojo.png' },
	{ id: 7, icono: './assets/media/puntos/spinnerAzul.png' },
	{ id: 8, icono: './assets/media/puntos/spinnerMorado.png' },
	{ id: 9, icono: './assets/media/puntos/spinnerCafe.png' },
	{ id: 10, icono: './assets/media/puntos/spinnerRosa.png' },
	{ id: 11, icono: './assets/media/puntos/spinnerGris.png' },
]

export const IconoHistorico = [
	{ id: 0, icono: './assets/media/marcadores/flechaGris.png' },
	{ id: 1, icono: './assets/media/marcadores/flechaVerde.png' },
	{ id: 2, icono: './assets/media/marcadores/flechaRoja.png' },
	{ id: 3, icono: './assets/media/marcadores/flechaAmarilla.png' },
	{ id: 4, icono: './assets/media/marcadores/flechaAmarilla.png' },
	{ id: 5, icono: './assets/media/marcadores/flechaNaranja.png' },
	{ id: 6, icono: './assets/media/marcadores/flechaRoja.png' },
	{ id: 7, icono: './assets/media/marcadores/flechaAzul.png' },
	{ id: 8, icono: './assets/media/marcadores/flechaMorada.png' },
	{ id: 9, icono: './assets/media/marcadores/flechaRosa.png' },
	{ id: 10, icono: './assets/media/marcadores/flechaCafe.png' },
	{ id: 11, icono: './assets/media/marcadores/flechaGris.png' },
]
